import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import Filter from 'features/processFlowDiagrams/svg/filters/filter.svg?react'
import GasFilter from 'features/processFlowDiagrams/svg/filters/gas-filter.svg?react'
import GasFilterBagCandleCartridge from 'features/processFlowDiagrams/svg/filters/gas-filter-bag-candle-cartridge.svg?react'
import GasFilterBeltRoll from 'features/processFlowDiagrams/svg/filters/gas-filter-belt-roll.svg?react'
import GasFilterFixedBed from 'features/processFlowDiagrams/svg/filters/gas-filter-fixed-bed.svg?react'
import GasFilterHepa from 'features/processFlowDiagrams/svg/filters/gas-filter-hepa.svg?react'
import LiquidFilter from 'features/processFlowDiagrams/svg/filters/liquid-filter.svg?react'
import LiquidFilterBagCandleCartridge from 'features/processFlowDiagrams/svg/filters/liquid-filter-bag-candle-cartridge.svg?react'
import LiquidFilterBeltRoll from 'features/processFlowDiagrams/svg/filters/liquid-filter-belt-roll.svg?react'
import LiquidFilterBiological from 'features/processFlowDiagrams/svg/filters/liquid-filter-biological.svg?react'
import LiquidFilterFixedBed from 'features/processFlowDiagrams/svg/filters/liquid-filter-fixed-bed.svg?react'
import LiquidFilterIonExchanger from 'features/processFlowDiagrams/svg/filters/liquid-filter-ion-exchanger.svg?react'
import LiquidFilterRotaryDrumOrDisc from 'features/processFlowDiagrams/svg/filters/liquid-filter-rotary-drum-or-disc.svg?react'
import LiquidFilterRotaryDrumOrDiscScraper from 'features/processFlowDiagrams/svg/filters/liquid-filter-rotary-drum-or-disc-scraper.svg?react'
import PressFilter from 'features/processFlowDiagrams/svg/filters/press-filter.svg?react'
import SuctionFilter from 'features/processFlowDiagrams/svg/filters/suction-filter.svg?react'
import React from 'react'

export const PID_FILTERS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'filter',
    name: 'Filter',
    category: 'filters',
    svgContent: <Filter />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'gas-filter',
    name: 'Gas Filter',
    category: 'filters',
    svgContent: <GasFilter />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'gas-filter-bag-candle-cartridge',
    name: 'Gas Filter (Bag, Candle, Cartridge)',
    category: 'filters',
    svgContent: <GasFilterBagCandleCartridge />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'gas-filter-belt-roll',
    name: 'Gas Filter (Belt, Roll)',
    category: 'filters',
    svgContent: <GasFilterBeltRoll />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'gas-filter-fixed-bed',
    name: 'Gas Filter (Fixed Bed)',
    category: 'filters',
    svgContent: <GasFilterFixedBed />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'gas-filter-hepa',
    name: 'Gas Filter (HEPA)',
    category: 'filters',
    svgContent: <GasFilterHepa />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'liquid-filter',
    name: 'Liquid Filter',
    category: 'filters',
    svgContent: <LiquidFilter />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'liquid-filter-bag-candle-cartridge',
    name: 'Liquid Filter (Bag, Candle, Cartridge)',
    category: 'filters',
    svgContent: <LiquidFilterBagCandleCartridge />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'liquid-filter-belt-roll',
    name: 'Liquid Filter (Belt, Roll)',
    category: 'filters',
    svgContent: <LiquidFilterBeltRoll />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'liquid-filter-biological',
    name: 'Liquid Filter (Biological)',
    category: 'filters',
    svgContent: <LiquidFilterBiological />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'liquid-filter-fixed-bed',
    name: 'Liquid Filter (Fixed Bed)',
    category: 'filters',
    svgContent: <LiquidFilterFixedBed />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'liquid-filter-ion-exchanger',
    name: 'Liquid Filter (Ion Exchanger)',
    category: 'filters',
    svgContent: <LiquidFilterIonExchanger />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'liquid-filter-rotary-drum-or-disc',
    name: 'Liquid Filter (Rotary, Drum or Disc)',
    category: 'filters',
    svgContent: <LiquidFilterRotaryDrumOrDisc />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'liquid-filter-rotary-drum-or-disc-scraper',
    name: 'Liquid Filter (Rotary, Drum or Disc, Scraper)',
    category: 'filters',
    svgContent: <LiquidFilterRotaryDrumOrDiscScraper />,
    viewBox: '0 0 55 100',
  },
  {
    id: 'press-filter',
    name: 'Press Filter',
    category: 'filters',
    svgContent: <PressFilter />,
    viewBox: '0 0 100 50',
  },
  {
    id: 'suction-filter',
    name: 'Suction Filter',
    category: 'filters',
    svgContent: <SuctionFilter />,
    viewBox: '0 0 50 100',
  },
]
